import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Card, CardBody, Col, Input, Label, Row, Table } from "reactstrap"
import { TextInput, Checkbox, DropdownSelect, RadioInput } from "../Inputs"
import PaymentForm from "../PaymentForm"
import DateInput from "components/Common/DateInput"
import { BranchOptions, FabricOptions } from "components/CustomSelect"
import DimensionInput from "components/Common/DimensionInput"
import { JPYFormat } from "util/currencyFormat"

export default function TrouserTab(props) {
  const { config, data, payload } = props
  const { handleInput } = config

  return (
    <Row>
      <Col sm={12}>
        <Card>
          <CardBody>
            <Row>
              <Col sm={6} className="pe-0">
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      {/**branch */}
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        店舗
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync={true}
                          loadOptions={config.loadBranch}
                          value={config.branch}
                          onChange={e => handleInput({ e, type: "storeId" })}
                          formatOptionLabel={item => (
                            <BranchOptions item={item} />
                          )}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      {/**order date */}
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        受注日
                      </td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          name="orderDate"
                          className="form-control"
                          value={payload.orderDate || ""}
                          onChange={([e]) =>
                            handleInput({ e, type: "orderDate" })
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      {/** customer */}
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        顧客名
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync
                          loadOptions={config.loadCustomer}
                          defaultOptions={config.customers}
                          value={config.customerId}
                          onChange={e => handleInput({ e, type: "customerId" })}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      {/**fabric company id */}
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        生地商社
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          defaultOptions={config.fabricTradings}
                          isAsync={true}
                          loadOptions={config.loadFabricTrading}
                          value={config.fabricTrading}
                          onChange={e =>
                            handleInput({ e, type: "fabricCompanyId" })
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      {/**fabric id */}
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        生地
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          isAsync
                          loadOptions={config.loadFabric}
                          options={config.fabrics}
                          defaultOptions={config.fabrics}
                          value={config.fabric}
                          onChange={e => handleInput({ e, type: "fabricId" })}
                          formatOptionLabel={item => (
                            <FabricOptions item={item} />
                          )}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        生地ランク
                      </td>
                      <td
                        style={{ padding: 5 }}
                        className="d-flex align-items-center justify-content-between"
                      >
                        <input
                          disabled
                          className="form-control"
                          value={payload.fabricRank}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p style={{ width: 119 }} className="mb-0 mx-2">
                          生地巾
                        </p>
                      </td>
                      <td style={{ padding: 5 }}>
                        <input
                          disabled
                          className="form-control"
                          value={payload.clothWidth}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ width: 107 }}>
                        <p className="mb-0">仮縫い</p>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div>
                            <Input
                              defaultChecked={payload.basting}
                              onClick={e =>
                                handleInput({ e, type: "basting", value: true })
                              }
                              className="me-2"
                              type="radio"
                              name="basting"
                              id="bastingOn"
                            />
                            <Label htmlFor="bastingOn" className="mb-0">
                              あり
                            </Label>
                          </div>

                          <div className="ms-5">
                            <Input
                              defaultChecked={!payload.basting}
                              onClick={e =>
                                handleInput({
                                  e,
                                  type: "basting",
                                  value: false,
                                })
                              }
                              className="me-2"
                              type="radio"
                              name="basting"
                              id="bastingOff"
                            />
                            <Label htmlFor="bastingOff" className="mb-0">
                              なし
                            </Label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        釦
                      </td>
                      <td style={{ padding: 5 }}>
                        <input
                          style={{ height: 33 }}
                          className="form-control"
                          defaultValue={payload.pants.button}
                          name="button"
                          onChange={e =>
                            handleInput({
                              e,
                              type: "button",
                              itemName: "pants",
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        プライス税別
                      </td>
                      <td style={{ padding: 5 }}>
                        {/* <input
                          style={{ height: 33 }}
                          className="form-control"
                          name="priceWithoutTax"
                          defaultValue={payload.pants.priceWithoutTax || ""}
                          value={payload.pants.priceWithoutTax || ""}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "priceWithoutTax",
                              itemName: "pants",
                            })
                          }
                          type="number"
                        /> */}

                        <DimensionInput
                          name="priceWithoutTax"
                          defaultValue={payload.pants.priceWithoutTax || ""}
                          value={payload.pants.priceWithoutTax || ""}
                          onValueChange={(e, name) =>
                            handleInput({
                              e,
                              type: name,
                              itemName: "pants",
                            })
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col sm={6} className="pe-0">
                <Table bordered>
                  <tbody>
                    <tr style={{ height: 54 }}>
                      <td>
                        <p className="mb-0">種別</p>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div>
                            <Input
                              defaultChecked={payload.type === "Bespoke"}
                              onClick={e => handleInput({ e, type: "type" })}
                              className="me-2"
                              type="radio"
                              id="BeSpoke"
                              name="type"
                              value="Bespoke"
                            />
                            <Label htmlFor="BeSpoke" className="mb-0">
                              Bespoke
                            </Label>
                          </div>

                          <div className="ms-5">
                            <Input
                              defaultChecked={payload.type === "MTM"}
                              onClick={e => handleInput({ e, type: "type" })}
                              className="me-2"
                              type="radio"
                              name="type"
                              id="MTM"
                              value="MTM"
                            />
                            <Label className="mb-0" htmlFor="MTM">
                              MTM
                            </Label>
                          </div>
                          <div className="ms-5">
                            <Input
                              defaultChecked={payload.type === "RTW"}
                              onClick={e => handleInput({ e, type: "type" })}
                              className="me-2"
                              type="radio"
                              name="type"
                              id="RTW"
                              value="RTW"
                            />
                            <Label className="mb-0" htmlFor="RTW">
                              RTW
                            </Label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td colSpan={2}>
                        <Input style={{ opacity: 0 }} type="radio" />
                      </td>
                    </tr>
                    <tr style={{ height: 54, opacity: config.guestHidden }}>
                      <td style={{ padding: 5, width: 105 }}>
                        <Input
                          defaultChecked={payload.guest}
                          disabled={!payload.guest || !config.guestHidden}
                          onChange={e => handleInput({ e, type: "guest" })}
                          name="guest"
                          type="checkbox"
                          id="新規お客様"
                        />
                        <Label className="ms-2 mb-0" htmlFor="新規お客様">
                          新規お客様
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <input
                          placeholder="ゲスト名を入力"
                          style={{ height: 33 }}
                          className="form-control w-100"
                          name="guestName"
                          defaultValue={payload.guestName}
                          disabled={!payload.guest}
                          onChange={e => handleInput({ e, type: "guestName" })}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: 5 }}>
                        <Label className="ms-2 mb-0">生地年度</Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          options={config.years}
                          value={config.year}
                          onChange={e => handleInput({ e, type: "year" })}
                          isDisabled={
                            !config.fabricTrading ||
                            config.fabricTrading?.value === ""
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: 5 }}>
                        <Label className="ms-2 mb-0">生地シーズン</Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <SelectBox
                          options={config.seasons}
                          value={config.season}
                          onChange={e => handleInput({ e, type: "seasonId" })}
                          className="w-100"
                          isDisabled={
                            !config.year ||
                            (config.year?.value === "" && !config.fabric) ||
                            config.fabric?.value === ""
                          }
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ padding: 5 }}>
                        <Label style={{ width: 109 }} className="ms-2 mb-0">
                          混率
                        </Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <input
                          disabled
                          // value={config.rank?.mixedRatio}
                          value={payload.mixedRatio}
                          style={{ height: 33 }}
                          className="form-control"
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ padding: 5 }}>
                        <Label className="ms-2 mb-0">用尺</Label>
                      </td>
                      <td style={{ padding: 5, position: "relative" }}>
                        <input
                          value={payload.pants.scale || ""}
                          defaultValue={payload.pants.scale || ""}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "scale",
                              itemName: "pants",
                            })
                          }
                          name="scale"
                          style={{ height: 33 }}
                          className="form-control scale-input"
                          type="number"
                        />
                        <p
                          style={{
                            position: "absolute",
                            right: 15,
                            top: 10,
                            opacity: 0.5,
                          }}
                        >
                          M
                        </p>
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        仮縫い日
                      </td>
                      <td style={{ padding: 5 }}>
                        <DateInput
                          style={{ height: 33 }}
                          className="form-control"
                          value={payload.fittingDate}
                          onChange={([e]) =>
                            handleInput({ e, type: "fittingDate" })
                          }
                          disabled={!payload.basting}
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        <Label className="ms-2 mb-0">糸色</Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <Input
                          defaultValue={payload.pants.threadColor}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "threadColor",
                              itemName: "pants",
                            })
                          }
                          name="threadColor"
                          style={{ height: 33 }}
                          className="form-control"
                        />
                      </td>
                    </tr>
                    <tr style={{ height: 54 }}>
                      <td style={{ minWidth: 105, verticalAlign: "middle" }}>
                        <Label className="ms-2 mb-0">プライス税込</Label>
                      </td>
                      <td style={{ padding: 5 }}>
                        <input
                          style={{ height: 33 }}
                          className="form-control"
                          disabled
                          readOnly
                          value={
                            payload.pants.priceTaxIncluded
                              ? JPYFormat(payload.pants.priceTaxIncluded)
                              : ""
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>

      <Col sm={12}>
        <Card>
          <CardBody>
            <Row>
              <Col sm={7}>
                {/**dimension */}
                <p>寸法</p>
                <Table bordered>
                  <thead>
                    <tr className="text-center">
                      <th style={{ minWidth: 105, position: "relative" }}>
                        <Input
                          type="text"
                          style={{ paddingLeft: 30 }}
                          value={payload.pants.tg}
                          disabled={payload.type === "Bespoke"}
                          onBlur={e =>
                            config.onTgBlur(e, ["トラウザーズ", "pants"])
                          }
                          onChange={e =>
                            handleInput({ e, type: "tg", itemName: "pants" })
                          }
                        />
                        <span
                          style={{
                            position: "absolute",
                            left: 16,
                            top: 18,
                            opacity: 0.5,
                          }}
                        >
                          Tg
                        </span>
                      </th>
                      <th>
                        {payload.type === "Bespoke" ? "ヌード" : "ゲージ寸法."}{" "}
                      </th>
                      <th>補正値</th>
                      <th>上り寸法</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.pants?.dimensions &&
                      data.pants.dimensions
                        .filter(dim => dim.item)
                        .map((obj, idx) => {
                          const payloadDim = payload.pants.dimensions
                          return (
                            <tr key={idx}>
                              <td>{obj.item}</td>
                              {["nude", "correctionValue", "riseDimension"].map(
                                t => (
                                  <td style={{ padding: 5 }} key={t}>
                                    <DimensionInput
                                      name={t}
                                      onValueChange={(val, name) =>
                                        handleInput({
                                          val,
                                          name,
                                          obj,
                                          idx,
                                          itemName: "pants",
                                          type: "dimensions",
                                        })
                                      }
                                      value={payloadDim[idx]?.[t]}
                                    />
                                  </td>
                                )
                              )}
                            </tr>
                          )
                        })}
                  </tbody>
                </Table>
              </Col>
              <Col sm={5}>
                <p>補正</p>
                <Table bordered>
                  <tbody>
                    {data?.pants?.corrections?.length
                      ? data.pants.corrections.map((corr, idx) => {
                          if (!corr.item) return null
                          const defaultValues = payload.pants.corrections
                          const inputProps = {
                            data: corr,
                            defaultValues,
                            itemName: "pants",
                            itemType: "corrections",
                            handler: handleInput,
                            index: idx,
                          }
                          return (
                            <tr key={idx}>
                              <td
                                style={{
                                  minWidth: 105,
                                  verticalAlign: "middle",
                                }}
                              >
                                {corr.item || "-"}
                              </td>
                              <td>
                                <Row className="gy-3">
                                  {corr.format === "ラジオボタン" ? ( // radio
                                    <RadioInput inputProps={inputProps} />
                                  ) : corr.format === "プルダウン" ? ( // select
                                    <DropdownSelect inputProps={inputProps} />
                                  ) : corr.format === "チェックボックス" ? ( // checkbox
                                    <Checkbox inputProps={inputProps} />
                                  ) : (
                                    // text input
                                    <TextInput inputProps={inputProps} />
                                  )}
                                </Row>
                              </td>
                            </tr>
                          )
                        })
                      : null}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <p>仕様</p>
            <Table bordered>
              <tbody>
                {data?.pants?.specifications?.length &&
                  data.pants.specifications
                    .filter(spec => spec.formId)
                    .map((spec, idx) => {
                      const defaultValues = payload.pants.specifications
                      const inputProps = {
                        data: spec,
                        defaultValues,
                        itemName: "pants",
                        handler: handleInput,
                        itemType: "specifications",
                        index: idx,
                      }
                      return spec.fomat === null ? (
                        <tr style={{ height: 54 }} key={idx}>
                          <td></td>
                        </tr>
                      ) : (
                        <tr key={idx} style={{ height: 54 }}>
                          <td style={{ maxWidth: "40px" }}>{spec.item}</td>
                          <td>
                            <Row>
                              {spec.format === "ラジオボタン" ? ( // radio
                                <RadioInput inputProps={inputProps} />
                              ) : spec.format === "プルダウン" ? ( // select
                                <DropdownSelect inputProps={inputProps} />
                              ) : spec.format === "チェックボックス" ? ( // checkbox
                                <Checkbox inputProps={inputProps} />
                              ) : (
                                // text input
                                <TextInput inputProps={inputProps} />
                              )}
                            </Row>
                          </td>
                        </tr>
                      )
                    })}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>

      {payload?.memo ? (
        <Col sm={12}>
          <Card>
            <CardBody>
              <p>メモ</p>
              <textarea
                className="form-control"
                rows={8}
                onChange={e => handleInput({ e, type: "memo" })}
              >
                {payload.memo}
              </textarea>
            </CardBody>
          </Card>
        </Col>
      ) : null}

      <Col sm={12}>
        <Row>
          <Col sm={5}>
            <Card>
              <CardBody>
                <Table bordered>
                  <tbody>
                    <tr>
                      <td style={{ width: 105 }}>
                        <p className="mb-0">納品方法</p>
                      </td>
                      <td>
                        <SelectBox
                          options={[
                            { label: "ご来店", value: "ご来店" },
                            { label: "ご配送", value: "ご配送" },
                            {
                              label: "次回オーダー会",
                              value: "次回オーダー会",
                            },
                          ]}
                          value={config.pantsDeliveryMethod}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "deliveryMethod",
                              itemName: "pants",
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 105 }}>
                        <p className="mb-0">サンプル</p>
                      </td>
                      <td>
                        <Input
                          defaultChecked={payload.pants.sample}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "sample",
                              itemName: "pants",
                            })
                          }
                          className="me-2"
                          type="checkbox"
                          id="サンプル"
                        />
                        <Label className="mb-0" htmlFor="サンプル">
                          サンプル
                        </Label>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Table bordered>
                  <tbody>
                    <tr>
                      <td style={{ width: 180 }}>ステータス</td>
                      {/* status */}
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          disabled
                          readOnly
                          value={config.productData.pants.status}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 180 }}>
                        下代
                        <br />
                        <small>※直販の場合は上代と同金額です</small>
                      </td>
                      {/* old age */}
                      <td>
                        <Input
                          type="number"
                          defaultValue={payload.pants.oldAge || ""}
                          value={payload.pants.oldAge || ""}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "oldAge",
                              itemName: "pants",
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 180 }}>予定納品日</td>
                      {/* scheduledDeliveryDate */}
                      <td>
                        <DateInput
                          className="form-control"
                          value={payload.pants.scheduledDeliveryDate}
                          onChange={e =>
                            handleInput({
                              e,
                              type: "scheduledDeliveryDate",
                              itemName: "pants",
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 180 }}>出来上日</td>
                      {/* completionDate */}
                      <td>
                        <DateInput
                          className="form-control"
                          disabled
                          value={config.productData.pants.completionDate}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 180 }}>製作者</td>
                      {/* producer */}
                      <td>
                        <Input
                          type="text"
                          disabled
                          readOnly
                          value={config.productData.pants.producer || ""}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: 180 }}>受注番号</td>
                      {/* orderNumber */}
                      <td>
                        <Input
                          type="text"
                          value={config.productData.orderNumber}
                          readOnly
                          disabled
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
          <Col sm={7}>
            <PaymentForm config={config} payload={payload} itemName="pants" />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
